import React from 'react';
import Mushi1 from './Mushi1.svg';
import MushiAndQuiz from './MushiAndQuiz.svg';
import Mushi2 from './Mushi2.svg';
import CreateQuizFull from './CreateQuizFull.svg';
import PlayQuizFull from './PlayQuizFull.svg';
import SearchQuiz from './SearchQuiz.svg';
import Hide from './Hide.svg';
import Unhide from './Unhide.svg';
import MemorizationCard from './MemorizationCard.svg';
import SignInWithGoogle from './SignInWithGoogle.png';
import AU from './AnonymousUser.svg';
    
const Mushi1Logo = ({...props}) => 
	<img src={Mushi1} {...props} alt='Mushi1'/>;

const Mushi2Logo = ({...props}) => 
	<img src={Mushi2} {...props} alt='Mushi2'/>;

const MushiAndQuizLogo = ({...props}) => 
	<img src={MushiAndQuiz} {...props} alt='Mushi And Quiz'/>;

const CreateQuizFullLogo = ({...props}) => 
	<img src={CreateQuizFull} {...props} alt='Create Quiz Full'/>;

const PlayQuizFullLogo = ({...props}) => 
	<img src={PlayQuizFull} {...props} alt='Play Quiz Full'/>;

const SearchQuizLogo = ({...props}) => 
	<img src={SearchQuiz} {...props} alt='Search Quiz'/>;

const HideLogo = ({...props}) => 
	<img src={Hide} {...props} alt='Hide'/>;

const UnhideLogo = ({...props}) => 
	<img src={Unhide} {...props} alt='Unhide'/>;

const MemorizationCardLogo = ({...props}) =>
	<img src={MemorizationCard} {...props} alt='MemorizationCard' />;

const SignInWithGoogleLogo = ({...props}) =>
	<img src={SignInWithGoogle} {...props} alt='SignInWithGoogle' />;

const AnonymousUser = ({...props}) =>
	<img src={AU} {...props} alt='AnonymousUser' />;
export {
	Mushi1Logo,
	Mushi2Logo,
	MushiAndQuizLogo,
	CreateQuizFullLogo,
	PlayQuizFullLogo,
	SearchQuizLogo,
	HideLogo,
	UnhideLogo,
	MemorizationCardLogo,
	SignInWithGoogleLogo,
	AnonymousUser
};
